import { AiUsagePage } from '@repo/ui/features/superadmin';

export default function SuperAdminAiUsagePage() {
  return (
    <div className="w-full py-6">
      <AiUsagePage />
    </div>
  );
}
